// JsFromRoutes CacheKey 69ed59b7019a22762fbf91373eed5645
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/event_images'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/event_images'),
}
